import React, { FC } from 'react'
import makeStyles from '@mui/styles/makeStyles';
import Typography from '@mui/material/Typography'
import Divider from '@mui/material/Divider'

import { getProps } from './utils'

import {
  FormFieldProps,
} from '../../../../types/frontend/form'

const useStyles = makeStyles(theme => ({
  heading: {
    marginTop: theme.spacing(2),
  },
  divider: {}
}))

const Heading: FC<React.PropsWithChildren<FormFieldProps>> = (props) => {
  const {
    item,
  } = getProps(props)

  const classes = useStyles()
  
  return (
    <>
      <Typography variant="h6" className={ classes.heading }>
        { item.title }
      </Typography>
      <Divider className={ classes.divider } />
    </>
  )
}

export default Heading